import FastMarquee from "react-fast-marquee";

const ITEMS = [
  "Recruitment",
  "Staffing",
  "HR Consulting",
  "Compliance",
  "Startup India",
  "Tax & GST",
  "Payroll",
  "Executive Search",
];

export default function ManifestoMarquee() {
  return (
    <section
      className="py-16 md:py-24 overflow-hidden border-b border-white/10"
      data-testid="manifesto-marquee"
    >
      <FastMarquee speed={40} pauseOnHover gradient={false}>
        {ITEMS.map((item, i) => (
          <span key={item} className="flex items-center">
            <span
              className={`font-heading text-5xl md:text-7xl font-bold uppercase tracking-tight px-6 md:px-10 ${
                i % 2 === 0 ? "text-outline" : "text-white"
              }`}
            >
              {item}
            </span>
            <span className="text-primary text-3xl md:text-5xl">✦</span>
          </span>
        ))}
      </FastMarquee>
    </section>
  );
}
